import FouUploader from 'components/form/fou-uploader/index.vue'
import FouUploadedItem from 'components/form/fou-uploaded-item/index.vue'
import FouGroup from 'components/layout/fou-group/'
import { watch } from 'vue'
import { Toaster } from 'src/utils/helper/toaster'
import i18n from 'src/assets/i18n/i18n'
import { MdTypography, MdIconSearchMalware } from '@antiqua-dls/vue-components'
import DOMPurify from 'dompurify';

import ImageInfo from '../image-info/index.vue'
const { t } = i18n().global

export default {
  components:{
    FouUploader,
    FouUploadedItem,
    ImageInfo,
    FouGroup,
    MdTypography,
    MdIconSearchMalware
  },

  props:{
    title:{
      type:String,
      default:''
    },
    description:{
      type:String,
      default:''
    },
    otherDescription: {
      type:String,
      default:''
    },
    type:{
      type:String,
      default:''
    },
    name:{
      type:String,
      default:''
    },
    rules:{
      type:String,
      default:''
    },
    errors:{
      type:String,
      default:{}
    },
    uploaderId:{
      type:String,
      default:''
    },
    thumbnailId:{
      type:String,
      default:''
    },
    criteriaTitle:{
      type:String,
      default:''
    },
    images:{
      type:String,
      default:[]
    },
    priority:{
      type:Number,
      default:1
    },
    dragText:{
      type:String,
      default:''
    },
    criteria:{
      type:String,
      default: ''
    },
    dataQaIdTitle: {
      type: String,
      default: 'bundle-image-title'
    },
    updateImagesSortOrder: {
      type: Function,
      required: true
    },
    showOptionalText: {
      type: Boolean,
      default: false
    },
    imageUploadStatus: {
      type: String,
      default: 'unset'
    },
    avCheckFalseFiles: {
      type: Array,
      default: []
    }
  },

  emits: ['update:thingsToKeepModal'],

  setup(props, { emit }){
    const openThingstoKeepInMindModal = () => {
      emit('update:thingsToKeepModal');
    }
    const sanitizeDescription = (description) => {
      return DOMPurify.sanitize(description)
    }

    watch(
      () => [props.avCheckFalseFiles],
      ([newValue]) => {
        if(newValue?.length){
          Toaster.notifyMalwareWarning(t('malwareScan.toastMessage'))
        }
      }
    )

    return {
      openThingstoKeepInMindModal,
      sanitizeDescription
    }
  },
}
